export const focusableElement = (element: any) => {
    if (element.tagName === 'INPUT' || element.tagName === 'TEXTAREA' || element.tagName === 'SELECT') {
        return true;
    }
    return false;
}